import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getVASPList } from "../../redux/actions/lookups/VASPList";

const useVASPList = () => {
  const dispatch = useDispatch();
  const vaspList = useSelector((state) => state.getVASPList.vaspList);
  
  useEffect(() => {
    if (!vaspList || vaspList.length === 0) {
      dispatch(getVASPList());
    }
  }, [dispatch, vaspList]);

  const formattedList = useMemo(() => {
    if (!vaspList) return [];

    return vaspList.map((vasp) => ({
      value: vasp.did, // dropdown value
      label: vasp.name, // text shown in dropdown
      id: vasp.id,
      website: vasp.website,
      logo: vasp.logo,
      country: vasp.incorporation_country,
    }));
  }, [vaspList]);

  return formattedList;
};

export default useVASPList;